
import { Component, inject, input, OnInit } from '@angular/core';
import { AuthService } from '@webapp/auth/services/auth.service';
import { ProspectsStoreService } from '@webapp/prospects/store/prospects-store.service';
import { IQuoteRow } from '@webapp/quotes/interfaces/quotes.interface';
import { QuotesStoreService } from '@webapp/quotes/store/quotes-store.service';
import { UserQuotesStoreService } from '@webapp/quotes/store/user-quotes-store.service';
import { UsersStoreService } from '../../../store/users-store.service';
import { PaginationComponent } from '@webapp/core/ui/components/pagination/pagination.component';
import { QuotesSidebarComponent } from '@webapp/quotes/ui/components/quote-sidebar/quotes-sidebar.component';
import { QuotesTableSkeletonComponent } from '@webapp/quotes/ui/components/quotes-table-skeleton/quotes-table-skeleton.component';
import { QuotesTableComponent } from '@webapp/quotes/ui/components/quotes-table/quotes-table.component';

@Component({
  selector: 'app-user-quotes',
  imports: [
    QuotesTableComponent,
    PaginationComponent,
    QuotesTableSkeletonComponent,
    QuotesSidebarComponent
],
  templateUrl: './user-quotes.component.html',
  styleUrl: './user-quotes.component.scss',
})
export class UserQuotesComponent implements OnInit {
  private store = inject(UserQuotesStoreService);
  private quotesStore = inject(QuotesStoreService);
  private userStore = inject(UsersStoreService);
  private prospectStore = inject(ProspectsStoreService);
  private authService = inject(AuthService);

  rows = this.store.getRows();
  canShowProducer = this.authService.isUserNotAgent();
  isProspect = input.required<boolean>();
  paginationStore = this.store.listStore.paginationStore;
  loading = this.store.listStore.select('loading');

  ngOnInit() {
    this.changePage();
  }

  public changePage() {
    const filters = this.isProspect()
      ? { prospectId: this.prospectStore.get()()?.id }
      : { client: { userId: this.userStore.get()()?.id } };

    if (Object.keys(filters).length) {
      this.store.listStore.set('filters', filters);
      this.store.listStore.fetch();
    }
  }

  openDetail(quote: IQuoteRow) {
    this.quotesStore.set('showSidebar', true);
    this.quotesStore.detailStore.fetch(quote.id);
  }
}
